// extracted by mini-css-extract-plugin
export default {"collapse":"styles_collapse__ujzc0","label_container":"styles_label_container__QG59x","label":"styles_label__BcfS4","info":"styles_info__FW9ai"};